import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import DropdownComponent from "../../../../../components/UI_Kit/Dropdown/Dropdown";

// Helper to generate a unique and valid controlId from the field name
const generateControlId = (fieldName) => {
  return fieldName.replace(/\s+/g, "-").toLowerCase(); // e.g., "type-du-support"
};

const TypeTwoForm = ({
  // Renamed component
  config, // Added config prop
  type2Data,
  handleChange,
  fileInputRef,
  handlePhotoUpload,
  showMenu,
  setShowMenu,
  handleOpenModal,
  handleDeletePhoto,
}) => {
  // Mapping from config field names to state keys in type2Data
  const fieldNameToStateKeyMap = {
    "Type du support": "supportType",
    "Type de Liaison": "installationType",
    "Type d'Alimentation": "powerSupplyType",
    // Add other mappings if relay_point has different/more fields in config
  };

  return (
    <>
      {/* Point Name - Remains unchanged */}
      <Row >
        <Col>
          <Form.Group controlId="pointName">
            <Form.Label>Nom du point</Form.Label>
            <Form.Control
              name="pointName"
              value={type2Data.pointName}
              onChange={handleChange}
              placeholder="Nommer le point"
            />
          </Form.Group>
        </Col>
      </Row>

      {/* Has Cameras - Remains unchanged */}
      <Row className="mb-4 mt-4">
        <Col>
          <Form.Group>
            <Form.Label>Présence de caméras sur le site ?</Form.Label>
            <div className="d-flex gap-4">
              <Form.Check
                type="radio"
                id="cameras-yes"
                label="Oui"
                name="hasCameras"
                value="yes"
                checked={type2Data.hasCameras === "yes"}
                onChange={handleChange}
              />
              <Form.Check
                type="radio"
                id="cameras-no"
                label="Non"
                name="hasCameras"
                value="no"
                checked={type2Data.hasCameras === "no"}
                onChange={handleChange}
              />
            </div>
          </Form.Group>
        </Col>
      </Row>

      {/* Location/Photos (Conditional) - Remains unchanged */}
      {type2Data.hasCameras === "yes" && (
        <Row className="mb-3">
          <Col>
            <Form.Group controlId="location">
              <Form.Label>Localisation*</Form.Label>
              <div
                className="photo-upload-box"
                onClick={() => fileInputRef.current.click()}
              >
                <span className="photo-upload-placeholder">
                  <img src="/camera.png" alt="Camera"></img> Ajouter une photo
                </span>
              </div>
              <Form.Control
                ref={fileInputRef}
                type="file"
                name="photo"
                accept="image/*"
                onChange={handlePhotoUpload}
                multiple
                hidden
              />
            </Form.Group>

            <div className="photo-preview-list">
              {type2Data.photos?.map((photo, index) => (
                <div key={index} className="photo-preview-item">
                  <div className="photo-preview-image-container">
                    <img
                      src={photo.url}
                      alt="Uploaded"
                      className="photo-preview-image"
                    />
                  </div>
                  <div className="photo-details">
                    <strong className="photo-title">
                      Localisation_Vue {index + 1}
                    </strong>
                    <span className="photo-name">
                    <img src="/picture.png" className="location-icon" alt="PIC NAME"></img>{" "}
                    {/* Limit photo name to 10 characters and add ellipsis if truncated */}
                    {photo.name ? (photo.name.length > 10 ? photo.name.substring(0, 10) + '...' : photo.name) : ''}
                  </span>
                  <span className="photo-meta">
                    <img src="/location.png" className="location-icon" alt="PIC METADATA"></img>{" "}
                    {/* Limit photo location to 20 characters and add ellipsis if truncated */}
                    {photo.location ? (photo.location.length > 20 ? photo.location.substring(0, 20) + '...' : photo.location) : "Pas de localisation"}
                  </span>
                  </div>
                  <div className="photo-actions">
                    <span
                      className="photo-options-btn"
                      onClick={() =>
                        setShowMenu(showMenu === index ? null : index)
                      }
                    >
                      ⋮
                    </span>
                    {showMenu === index && (
                    <div className="custom-dropdown-menu">
                      <div className="dropdown-arrow" />
                      <button
                        className="custom-dropdown-item"
                        onClick={() => {
                          handleOpenModal(index);
                          setShowMenu(null);
                        }}
                      >
                        <img src="/edit_alt.png" className="action-icon"></img> {" "}
                        Modifier
                      </button>
                      <button
                        className="custom-dropdown-item"
                        onClick={() => {
                          handleDeletePhoto(index);
                          setShowMenu(null);
                        }}
                      >
                        <img src="/close.png" className="action-icon"></img> {" "}
                        Supprimer
                      </button>
                    </div>
                  )}
                  </div>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      )}

      {/* Dynamically generated select fields */}
      {config?.fields &&
        Object.entries(config.fields).map(([fieldName, options]) => {
          const stateKey = fieldNameToStateKeyMap[fieldName];
          const controlId = generateControlId(fieldName);

          // Only render if we have a mapping for the field name to a state key
          if (!stateKey) {
            console.warn(
              `No state key mapping found for config field: ${fieldName} in TypeTwoForm`
            );
            return null; // Skip rendering this field
          }

          // Skip rendering if cameras are not present and the field is related to camera specifics (if any)
          // Add specific checks here if needed, e.g., if (type2Data.hasCameras !== 'yes' && stateKey === 'someCameraSpecificField') return null;

          return (
            <Row className="mb-3" key={controlId}>
              <Col>
                <Form.Group controlId={controlId}>
                  <Form.Label>{fieldName}*</Form.Label>{" "}
                  {/* Use fieldName as label */}
                  <DropdownComponent
                    name={stateKey} // Use the mapped state key for the name attribute
                    value={type2Data[stateKey]} // Access value using the mapped state key
                    onChange={handleChange}
                    options={options}
                    placeholder="Sélectionner..."
                  />
                </Form.Group>
              </Col>
            </Row>
          );
        })}

      {/* Comment - Remains unchanged */}
      <Row>
        <Col>
          <Form.Group controlId="comment">
            <Form.Label>Commentaire</Form.Label>{" "}
            <Form.Control
              as="textarea"
              name="comment"
              value={type2Data.comment}
              onChange={handleChange}
              placeholder="Ajouter un commentaire..."
              maxLength={300}
              className="comment-box"
            />
            <div className="char-counter">
              {type2Data.comment?.length || 0}/300
            </div>
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};

export default TypeTwoForm; // Updated export name
